"use strict";

angular.module('rmPresenter')
    .factory('Presenter', require('./presenter.js'));